<template>
  <modal
    name="editUserModal"
    :width="modalWidth"
    :minHeight="200"
    :minWidth="200"
    :maxWidth="1300"
    :scrollable="true"
    :adaptive="true"
    :reset="true"
    height="auto"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="modal--container">
      <div class="d-flex justify-content-end pt-3">
        <button @click="closeModal" class="close">
          <span aria-hidden="true"
            ><font-awesome-icon icon="times" size="1x"
          /></span>
        </button>
      </div>

      <form v-on:submit.prevent="saveEmp" class="mt-3">
        <div class="row my-2 flex-column flex-md-row">
          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>First Name *</label>
            <input
              type="text"
              v-model="employeeDetails.first_name"
              placeholder="John"
              required
            />
          </div>
          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Last Name *</label>
            <input
              type="text"
              v-model="employeeDetails.last_name"
              placeholder="Doe"
              required
            />
          </div>
          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Email</label>
            <input
              type="email"
              v-model="employeeDetails.email"
              placeholder="john@doe.com"
              disabled
            />
          </div>
        </div>
        <div class="row flex-column flex-md-row my-2">
          <div
            :class="{
              'col-12 col-md-8 form-group low-opacity': true,
              'full-opacity': officeTeams && officeTeams.length > 0
            }"
          >
            <label>Team *</label>
            <multiselect
              v-model="employeeDetails.team"
              :multiple="true"
              label="name"
              track-by="id"
              placeholder="Select a team"
              :options="officeTeamsOptions"
              :required="officeTeams.length > 0"
            ></multiselect>
          </div>
          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Title</label>
            <input type="text" v-model="employeeDetails.designation" />
          </div>
        </div>
        <div class="row flex-column flex-md-row my-2">
          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Reminder 1</label>
            <select v-model="employeeDetails.first_reminder">
              <option selected value="no reminder">No reminder</option>
              <option
                v-for="(timeSlot, index) in reminderOptions"
                :value="timeSlot"
                :key="index"
                v-show="isReminderChosen(timeSlot)"
              >
                {{ timeSlot + " minutes" }}
              </option>
            </select>
          </div>
          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Reminder 2</label>
            <select v-model="employeeDetails.second_reminder">
              <option :selected="true" value="no reminder">No reminder</option>
              <option
                v-for="(timeSlot, index) in reminderOptions"
                :value="timeSlot"
                :key="index"
                v-show="isReminderChosen(timeSlot)"
              >
                {{ timeSlot + " minutes" }}
              </option>
            </select>
          </div>
          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Reminder 3</label>
            <select v-model="employeeDetails.third_reminder">
              <option :selected="true" value="no reminder">No reminder</option>
              <option
                v-for="(timeSlot, index) in reminderOptions"
                :value="timeSlot"
                :key="index"
                v-show="isReminderChosen(timeSlot)"
              >
                {{ timeSlot + " minutes" }}
              </option>
            </select>
          </div>
        </div>

        <div class="row flex-column flex-md-row mt-2">
          <div
            class="d-flex flex-column col-12 col-md-4 form-group edit-modal-item"
          >
            <label>Subsidy Type *</label>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center mr-4">
                <input
                  class="mr-2"
                  type="radio"
                  id="daily"
                  value="daily"
                  v-model="employeeDetails.subsidy_type"
                />
                <label for="daily">Daily</label>
              </div>

              <div class="d-flex align-items-center">
                <input
                  class="mr-2"
                  type="radio"
                  id="weekly"
                  value="weekly"
                  v-model="employeeDetails.subsidy_type"
                />
                <label for="weekly">Weekly</label>
              </div>
            </div>
          </div>

          <!-- <div
          <div
            class="d-flex flex-column col-12 col-md-4 form-group edit-modal-item"
          >
            <label>Meal</label>
            <select class="form-control" v-model="meal">
              <option value="lunch" selected>Lunch</option>
              <option value="dinner">Dinner</option>
            </select>
          </div> -->
        </div>

        <div class="row mt-2">
          <div
            v-if="employeeDetails.subsidy_type == 'daily'"
            class="col-12 form-group edit-modal-item"
          >
            <label style="font-weight: 500">Daily Subsidy</label>
            <div
              class="d-flex flex-wrap flex-column flex-md-row dailyLimits_container mb-1"
            >
              <div class="col-md-4 dailyLimit_item">
                <label>Monday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.monday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item">
                <label>Tuesday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.tuesday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item">
                <label>Wednesday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.wednesday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item">
                <label>Thursday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.thursday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item">
                <label>Friday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.friday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item">
                <label>Saturday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.saturday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item">
                <label>Sunday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.sunday"
                />
              </div>
            </div>
          </div>

          <div v-else class="col-12 form-group edit-modal-item">
            <label style="font-weight: 500">Weekly Subsidy</label>
            <div class="row dailyLimits_container mb-1">
              <div class="col-4 dailyLimit_item">
                <label>Subsidy</label>
                <input
                  v-clear
                  required
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.subsidy"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div
            class="col-12 form-group edit-modal-item change-password"
            v-if="showChangePassword"
          >
            <span class="">Change Password</span>
            <div class="col-12 d-flex flex-column flex-md-row">
              <div class="col-6 d-flex flex-column">
                <label>New Password</label>
                <password-input v-model="newPassword" />
              </div>
              <div class="col-6 d-flex flex-column">
                <label>Reenter New Password</label>
                <password-input v-model="confirmNewPassword" />
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-1 mb-3">
          <div v-if="error" class="col-12 alert alert-danger alert-dismissible">
            <p>{{ this.error }}</p>
          </div>

          <div
            v-if="message"
            class="col-12 alert alert-success alert-dismissible mb-2"
          >
            <strong>{{ message }}</strong>
          </div>

          <div class="d-flex flex-column flex-md-row w-100 justify-content-end">
            <div class="col my-1 my-md-0">
              <button type="submit" class="save_btn hover-dark">Save</button>
            </div>

            <div class="col my-1 my-md-0">
              <button
                type="button"
                class="save_btn hover-dark"
                @click.prevent="sendResetPassword()"
              >
                Send Password Reset Link
              </button>
            </div>

            <div class="col my-1 my-md-0">
              <button
                class="other_btn hover-gray"
                @click.prevent="changePasswordModal()"
              >
                Change Password
              </button>
            </div>

            <div class="col my-1 my-md-0">
              <button class="other_btn hover-gray" @click.prevent="closeModal">
                Close
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>
<script>
import { updateEmployee, forgotPassword } from "../../utils/api";
import { mapGetters } from "vuex";
import { errorHandler } from "@/utils/errorHandler";
import {
  parseDailySubsidy,
  parseWeeklySubsidy,
  validatePassword
} from "../../utils/common";
import PasswordInput from "@/components/PasswordInput";
import Multiselect from "vue-multiselect";

export default {
  name: "AdminEditUserModal",
  data() {
    return {
      employeeDetails: {
        first_name: "",
        last_name: "",
        daily_limits: {},
        team: []
      },
      modalWidth: "95%",
      employeeId: null,
      officeTeams: [],
      allItems: 0,
      currentDailySubsidy: {},
      remainingDailySubsidy: {},
      dailyLunchSubsidy: [],
      dailyDinnerSubsidy: [],
      firstName: "",
      newPassword: "",
      confirmNewPassword: "",
      showChangePassword: false,
      error: "",
      message: "",
      meal: "lunch",
      subsidy: "daily",
      reminderOptions: ["15", "30", "45", "60", "90", "120", "180"]
    };
  },
  components: {
    PasswordInput,
    Multiselect
  },
  beforeDestroy() {
    document.body.classList.remove("noscroll");
  },
  computed: {
    ...mapGetters(["getFirstEmployeeId"]),
    officeTeamsOptions() {
      return this.officeTeams
        ?.filter(team => {
          return !this.employeeDetails.team?.some(
            selectedTeam => selectedTeam.id == team.id
          );
        })
        .map(team => {
          return {
            name: team?.attributes?.name,
            id: team?.id
          };
        });
    }
  },
  mounted() {
    this.modalWidth = window.innerWidth >= 768 ? "70%" : "95%";
  },
  methods: {
    filterKey(e) {
      let key = e.keyCode || e.charCode;
      if (
        key !== 9 &&
        key !== 8 &&
        key !== 46 &&
        key !== 190 &&
        key !== 40 &&
        key !== 37 &&
        key !== 39 &&
        key !== 38
      ) {
        if (!e?.key?.trim() || isNaN(e.key)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }
    },
    beforeOpen(event) {
      this.message = "";
      this.error = "";
      this.employeeDetails = JSON.parse(
        JSON.stringify(
          event.params?.employee && event.params?.employee?.attributes
        )
      );

      this.employeeId = JSON.parse(
        JSON.stringify(event.params?.employee && event?.params?.employee?.id)
      );

      this.employeeDetails.team =
        event?.params?.employee?.attributes?.teams?.map(team => ({
          name: team.name,
          id: team.id
        })) ?? [];

      if (this.employeeDetails.subsidy > 0) this.subsidy_type = "weekly";
      this.officeTeams = JSON.parse(JSON.stringify(event?.params?.officeTeams));
      if (this.officeTeams.length == 1)
        this.employeeDetails.team = this.officeTeams[0].id;
    },
    changePasswordModal(employeeDetails) {
      this.showChangePassword = !this.showChangePassword;
    },
    closeModal() {
      this.$modal.hide("editUserModal");
    },
    beforeClose() {
      document.body.classList.remove("noscroll");
      this.showChangePassword = false;
    },
    saveEmp(event) {
      const empDetails = this.employeeDetails;
      const params = {
        email: empDetails.email,
        location_employee: {
          designation: empDetails.designation,
          subsidy_type: empDetails.subsidy_type,
          subsidy: parseWeeklySubsidy(empDetails.subsidy),
          team_ids: empDetails.team?.map(team => team.id),
          daily_subsidy: parseDailySubsidy(empDetails.daily_subsidy),
          employee_attributes: {
            id: empDetails.id,
            user_attributes: {
              id: empDetails.user_id,
              first_name: empDetails?.first_name,
              last_name: empDetails.last_name,
              first_reminder: empDetails.first_reminder,
              second_reminder: empDetails.second_reminder,
              third_reminder: empDetails.third_reminder
            }
          }
        }
      };

      if (
        this.officeTeams &&
        this.officeTeams.length > 0 &&
        !this.employeeDetails.team
      ) {
        this.error = "You must select a team";
        return;
      }

      const result = validatePassword(this.newPassword);

      if (this.showChangePassword) {
        if (!this.newPassword || this.newPassword === "") {
          this.error = "You must provide a password";
          return;
        } else if (this.newPassword !== this.confirmNewPassword) {
          this.error = "Password and Confirm Password does not match";
          return;
        } else if (!result) {
          this.error =
            "The password should contain at least one number and letter with a minimum of 8 characters";
          return;
        } else {
          params.location_employee.employee_attributes.user_attributes.password = this.newPassword;
          params.location_employee.employee_attributes.user_attributes.password_confirmation = this.newPassword;
        }
      }

      if (this.subsidy_type == "weekly") {
        params.subsidy = parseFloat(empDetails.subsidy);
      }

      let loader = this.$loading.show();

      updateEmployee(params, this.employeeId, this.getFirstEmployeeId)
        .then(res => {
          loader.hide();
          if (res.data && !res.data.employee)
            this.error =
              res.data.message instanceof Array
                ? res.data.message.join(",")
                : res.data.message;
          else {
            this.closeModal();
            this.resetStates();
            this.$root.$emit("onGetEmployees");
          }
        })
        .catch(err => {
          loader.hide();
        });
    },
    resetStates() {
      this.error = "";
      this.showChangePassword = false;
      this.newPassword = "";
      this.confirmNewPassword = "";
    },
    isReminderChosen(timeSlot) {
      const currentSelectedReminders = [
        +this.employeeDetails.reminder_1_value,
        +this.employeeDetails.reminder_2_value,
        +this.employeeDetails.reminder_3_value
      ];
      return !currentSelectedReminders.includes(timeSlot);
    },
    sendResetPassword() {
      let loader = this.$loading.show();
      forgotPassword(this.employeeDetails.email)
        .then(response => {
          loader.hide();
          if (response) {
            this.message =
              "Password reset instructions have been sent to the user, please ask them to check their email(including spam folder).";
          } else {
            this.message = "";
            this.error = "Email provided is not associated with any account.";
          }
        })
        .catch(err => {
          loader.hide();
          errorHandler(err);
        });
    }
  },
  directives: {
    clear: {
      bind: function(el, binding, vnode) {
        el.onfocus = function() {
          if (parseFloat(el.value) === 0) {
            el.value = null;
          }
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 24px;
  font-weight: 700;
}

.low-opacity {
  opacity: 0.5;
}

.full-opacity {
  opacity: 1;
}

.dailyLimit_item {
  display: flex;
  flex-direction: column;
  // justify-content: center;
  // align-items: flex-start;
  margin-bottom: 8px;
}

.dailyLimit_item input {
  width: 140px;
}

.dailyLimit_item label {
  font-size: 14px;
  font-weight: normal;
  color: #000;
  margin-bottom: 6px;
}

.col {
  flex-grow: 0;
}

.modal--container {
  padding: 0 20px;
  overflow: auto;
}

.change-password span {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  margin-bottom: 16px;
}

.change-password label {
  font-size: 14px;
  font-weight: 600;
  color: #000;
  margin-bottom: 16px;
}

@media (max-width: 768px) {
  .dailyLimit_item input {
    width: 100%;
  }

  .save_btn {
    width: 100%;
  }

  .other_btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OfficeAdmin/AdminEditUserModal.vue